import { useEffect, useState } from 'react';

import { sendLogo } from 'config/requests/methodLogos';
import { MethodLogosCreateForm } from 'pages/MethodLogos/MethodLogosCreate/MethodLogosCreateForm';
import { useNotify } from 'react-admin';
import { FormProvider, useForm } from 'react-hook-form';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';

type MethodLogosCreateLogoModalProps = {
  onSetLogo: (id: string) => void;
} & DialogProps;

type MethodLogosCreateFormValues = {
  file?: FileList;
  filePath: string;
  name: string;
};

export const MethodsLogoCreateLogoModal: React.FC<MethodLogosCreateLogoModalProps> = ({
  onClose,
  open,
  onSetLogo,
}) => {
  const notify = useNotify();
  const [errors, setErrors] = useState<any>();
  const form = useForm({
    defaultValues: {
      name: '',
      filePath: '',
      file: undefined,
    },
  });

  const { reset } = form;

  useEffect(() => {
    if (open) {
      reset();
      setErrors(undefined);
    }
  }, [open, reset]);

  const submitForm = (data: MethodLogosCreateFormValues) => {
    if (data?.file?.[0]) {
      const formData = new FormData();
      formData.append('file', data.file[0]);
      formData.append('name', data.name);

      sendLogo(formData)
        .then((response: any) => {
          notify('Логотип создан!', { type: 'info' });
          onSetLogo(`/admin/method_logos/${response.id}`);
          onClose();
        })
        .catch((e) => setErrors(e?.data));
    } else {
      notify('Загрузите логотип!', { type: 'error' });
    }
  };

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title="Загрузка логотипа"
        titleSize="smallBold"
      />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submitForm)}>
          <CardContent>
            <MethodLogosCreateForm errors={errors} />
          </CardContent>
          <CardActionsButtons
            rightActionsSlot={[
              <CancelButton key="method-logos-cancel" onClick={onClose} variant="outlined" />,
              <SaveButton key="save-button" label="Добавить" />,
            ]}
          />
        </form>
      </FormProvider>
    </Dialog>
  );
};
